import { IDateService } from '../../interface/date.interface';

/**
 * @deprecated
 * Please don't use moment; it will likely cause a huge performance overhead because of its complex APIs and large bundle size.
 * I am leaving this here just to bring attention to NOT use moment.
 * https://github.com/you-dont-need/You-Dont-Need-Momentjs
 * https://momentjs.com/docs/#/-project-status/
 */
export class MomentDateService extends Date implements IDateService {
    constructor(date: Date | string | number) {
        super(date);
    }

    public addDays(days: number): this {
        throw new Error('Method not implemented.');
    }

    public addMonths(months: number): this {
        throw new Error('Method not implemented.');
    }

    public addYears(years: number): this {
        throw new Error('Method not implemented.');
    }

    public subtractDays(days: number): this {
        throw new Error('Method not implemented.');
    }

    public subtractMonths(months: number): this {
        throw new Error('Method not implemented.');
    }

    public subtractYears(years: number): this {
        throw new Error('Method not implemented.');
    }

    public format(format?: string): string {
        throw new Error('Method not implemented.');
    }

    public toDate(): Date {
        throw new Error('Method not implemented.');
    }

    public override getDay(): number {
        throw new Error('Method not implemented.');
    }

    public override getMonth(): number {
        throw new Error('Method not implemented.');
    }

    public getYear(): number {
        throw new Error('Method not implemented.');
    }

    public setDates(date: number): this {
        throw new Error('Method not implemented.');
    }

    public setMonths(month: number): this {
        throw new Error('Method not implemented.');
    }

    public setYears(year: number): this {
        throw new Error('Method not implemented.');
    }

    public startOfDay(): this {
        throw new Error('Method not implemented.');
    }

    public startOfMonth(): this {
        throw new Error('Method not implemented.');
    }

    public startOfYear(): this {
        throw new Error('Method not implemented.');
    }

    public isSameDay(date: this): boolean {
        throw new Error('Method not implemented.');
    }

    public isSameMonth(date: this): boolean {
        throw new Error('Method not implemented.');
    }

    public isBefore(date: this): boolean {
        throw new Error('Method not implemented.');
    }

    public isAfter(date: this): boolean {
        throw new Error('Method not implemented.');
    }

    public isSameOrBefore(date: this | Date): boolean {
        throw new Error('Method not implemented.');
    }

    public differenceInDays(date: this | Date): number {
        throw new Error('Method not implemented.');
    }

    public differenceInMonths(date: this | Date): number {
        throw new Error('Method not implemented.');
    }
}
